const colors = {
  background: '#ffffff',
  background_card: '#FFFFFF',

  primary_color: '#542288',
  primary_color_dark: '#542288',
  primary_color_light: '#542288',
  primary_color_light2: '#542288',

  gray: '#d4d4d4',
  gray_light: '#eeeeee',

  white: '#ffffff',
  yellow: '#FFCE00',
  yellow_light: '#fae54c',
  green: '#542288',

  red_error: '#c53030',

  text_black: '#353232',
  text_white: '#ffffff',
  text_gray: '#646464',

  icon_black: '#353232',
};

export default colors;
